const Spinner = () => (
  <div className="eva-spinner">
    <div>
      <i className="ll-icon ll-logo-eva-small" />
      <i className="lnr lnr-briefcase" />
      <i className="lnr lnr-user" />
      <div />
    </div>
  </div>
);

// eslint-disable-next-line import/no-default-export
export default Spinner;
